
import { entitySlice } from './entities';
import userReducer from './user';
import uiReducer from './ui';
import upperLevelReducer from './upperLevelReducers';
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["user"],
};

export const uncoupledReducer = combineReducers({
	user: userReducer,
	entity: entitySlice.reducer,
	ui: uiReducer,
	// navigator: createRouterReducer(history)
});

const combinedReducer = combineReducers({
	user: userReducer,
	entity: entitySlice.reducer,
	ui: uiReducer,
});

export const rootReducer = (state, action) => {
	const intermediateState = upperLevelReducer(state, action);
	const finalState = combinedReducer(intermediateState, action);
	return finalState;
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);



